import { render, staticRenderFns } from "./transaction-1.vue?vue&type=template&id=169cbaf0&"
import script from "./transaction-1.vue?vue&type=script&lang=ts&"
export * from "./transaction-1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports